import React, { useState } from 'react';
import { useAuth } from './AuthContext';
import Passengers from './Passengers';
import Requests from './Requests';
import Destinations from './Destinations';
import Accommodations from './Accommodations';
import Budgets from './Budgets';
import Bookings from './Bookings';

function MainPage() {
  const { logout } = useAuth();
  const [currentView, setCurrentView] = useState('dashboard');
  const [showLogoutModal, setShowLogoutModal] = useState(false);
  const [budgetInitialData, setBudgetInitialData] = useState(null);
  const [bookingInitialData, setBookingInitialData] = useState(null);

  const handleLogout = () => {
    setShowLogoutModal(true);
  };

  const confirmLogout = () => {
    logout();
    setShowLogoutModal(false);
  };

  const cancelLogout = () => setShowLogoutModal(false);

  const handleGenerateBudget = (data) => {
    setBudgetInitialData(data);
    setCurrentView('budgets');
  };

  const handleGenerateBooking = (data) => {
    setBookingInitialData(data);
    setCurrentView('bookings');
  };

  return (
    <div style={styles.container}>
      <header style={styles.header}>
        <div style={styles.whiteSection}>
          <img src="/images/logo.png" alt="Sol Travel Logo" style={styles.logo} />
        </div>
        <div style={styles.orangeSection}>
          <button onClick={handleLogout} style={styles.logoutButton}>Cerrar Sesión</button>
          <h1 style={styles.headerTitle}>Sol Travel</h1>
          <p style={styles.headerSubtitle}>Bienvenido a tu panel de viajes</p>
        </div>
      </header>
      <nav style={styles.nav}>
        <button 
          onClick={() => setCurrentView('dashboard')} 
          style={currentView === 'dashboard' ? styles.activeNavButton : styles.navButton}
        >
          Panel de Control
        </button>
        <button 
          onClick={() => setCurrentView('destinations')} 
          style={currentView === 'destinations' ? styles.activeNavButton : styles.navButton}
        >
          Destinos
        </button>
        <button 
          onClick={() => setCurrentView('accommodations')} 
          style={currentView === 'accommodations' ? styles.activeNavButton : styles.navButton}
        >
          Alojamientos
        </button>
        <button 
          onClick={() => setCurrentView('passengers')} 
          style={currentView === 'passengers' ? styles.activeNavButton : styles.navButton}
        >
          Pasajeros
        </button>
        <button 
          onClick={() => setCurrentView('requests')} 
          style={currentView === 'requests' ? styles.activeNavButton : styles.navButton}
        >
          Solicitudes
        </button>
        <button 
          onClick={() => setCurrentView('budgets')} 
          style={currentView === 'budgets' ? styles.activeNavButton : styles.navButton}
        >
          Presupuestos
        </button>
        <button 
          onClick={() => setCurrentView('bookings')} 
          style={currentView === 'bookings' ? styles.activeNavButton : styles.navButton}
        >
          Reservas
        </button>
      </nav>
      <main style={styles.main}>
        {currentView === 'dashboard' && (
          <div style={styles.card}>
            <h2>Panel de Control</h2>
            <p>Has iniciado sesión exitosamente en Sol Travel.</p>
            <div style={styles.quickActions}>
              <h3>Acciones Rápidas</h3>
              <button 
                onClick={() => setCurrentView('destinations')} 
                style={styles.quickActionButton}
              >
                🌍 Nuestros Destinos
              </button>
              <button 
                onClick={() => setCurrentView('accommodations')} 
                style={styles.quickActionButton}
              >
                🏨 Gestionar Alojamientos
              </button>
              <button 
                onClick={() => setCurrentView('passengers')} 
                style={styles.quickActionButton}
              >
                👥 Gestionar Pasajeros
              </button>
              <button 
                onClick={() => setCurrentView('requests')} 
                style={styles.quickActionButton}
              >
                📋 Gestionar Solicitudes
              </button>
              <button 
                onClick={() => setCurrentView('budgets')} 
                style={styles.quickActionButton}
              >
                💰 Gestionar Presupuestos
              </button>
              <button 
                onClick={() => setCurrentView('bookings')} 
                style={styles.quickActionButton}
              >
                📅 Gestionar Reservas
              </button>
            </div>
          </div>
        )}
        {currentView === 'passengers' && <Passengers />}
        {currentView === 'requests' && <Requests onGenerateBudget={handleGenerateBudget} />}
        {currentView === 'destinations' && <Destinations />}
        {currentView === 'accommodations' && <Accommodations />}
        {currentView === 'budgets' && <Budgets initialData={budgetInitialData} onClearInitialData={() => setBudgetInitialData(null)} onGenerateBooking={handleGenerateBooking} />}
        {currentView === 'bookings' && <Bookings initialData={bookingInitialData} onClearInitialData={() => setBookingInitialData(null)} />}
      </main>

      {showLogoutModal && (
        <div style={styles.modalOverlay}>
          <div style={styles.modal}>
            <h3 style={styles.modalTitle}>Confirmar Cierre de Sesión</h3>
            <p style={styles.modalText}>¿Estás seguro de que deseas cerrar sesión?</p>
            <div style={styles.modalButtons}>
              <button onClick={cancelLogout} style={styles.modalCancelButton}>Cancelar</button>
              <button onClick={confirmLogout} style={styles.modalConfirmButton}>Cerrar Sesión</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

const styles = {
  container: {
    minHeight: '100vh',
    backgroundColor: '#f8f9fa'
  },
  header: {
    display: 'flex',
    color: 'white'
  },
  whiteSection: {
    backgroundColor: 'white',
    width: '150px',
    padding: '10px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  orangeSection: {
    backgroundColor: '#ff9f43',
    flex: 1,
    padding: '20px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    width: '100%',
    position: 'relative'
  },
  logo: {
    height: '100%',
    width: '100%',
    maxHeight: '100px',
    objectFit: 'contain'
  },
  headerTitle: {
    margin: '0 auto 10px auto',
    fontSize: '40px',
    textAlign: 'center'
  },
  headerSubtitle: {
    margin: '0',
    fontSize: '24px',
    opacity: 0.9,
    textAlign: 'center'
  },
  nav: {
    backgroundColor: 'white',
    padding: '10px 20px',
    borderBottom: '1px solid #ddd',
    display: 'flex',
    gap: '10px'
  },
  navButton: {
    padding: '14px 24px',
    border: 'none',
    backgroundColor: 'transparent',
    cursor: 'pointer',
    borderRadius: '4px',
    fontSize: '18px'
  },
  activeNavButton: {
    padding: '14px 24px',
    border: 'none',
    backgroundColor: '#ff9f43',
    color: 'white',
    cursor: 'pointer',
    borderRadius: '4px',
    fontSize: '18px'
  },
  main: {
    padding: '10px',
    maxWidth: '100%',
    margin: '0 auto'
  },
  card: {
    backgroundColor: 'white',
    padding: '30px',
    borderRadius: '8px',
    boxShadow: '0 2px 10px rgba(0,0,0,0.1)',
    fontSize: '20px'
  },
  quickActions: {
    marginTop: '30px',
    paddingTop: '20px',
    borderTop: '1px solid #e9ecef'
  },
  quickActionButton: {
    backgroundColor: '#ff9f43',
    color: 'white',
    padding: '18px 30px',
    border: 'none',
    borderRadius: '8px',
    fontSize: '20px',
    fontWeight: '500',
    cursor: 'pointer',
    boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
    marginRight: '10px',
    marginBottom: '10px'
  },
  logoutButton: {
    position: 'absolute',
    top: '20px',
    right: '20px',
    padding: '10px 20px',
    border: 'none',
    backgroundColor: 'white',
    color: '#e67e22',
    cursor: 'pointer',
    borderRadius: '8px',
    fontSize: '16px',
    fontWeight: 'bold',
    boxShadow: '0 4px 8px rgba(0,0,0,0.15)'
  },
  modalOverlay: { position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, backgroundColor: 'rgba(0,0,0,0.5)', display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 1000 },
  modal: { backgroundColor: 'white', padding: '30px', borderRadius: '12px', boxShadow: '0 4px 12px rgba(0,0,0,0.3)', maxWidth: '400px', width: '90%' },
  modalTitle: { fontSize: '28px', fontWeight: '600', marginBottom: '15px', color: '#333', textAlign: 'center' },
  modalText: { fontSize: '20px', color: '#495057', marginBottom: '25px', textAlign: 'center', lineHeight: '1.5' },
  modalButtons: { display: 'flex', gap: '12px', justifyContent: 'center' },
  modalCancelButton: { backgroundColor: '#6c757d', color: 'white', padding: '16px 32px', border: 'none', borderRadius: '6px', fontSize: '18px', fontWeight: '500', cursor: 'pointer' },
  modalConfirmButton: { backgroundColor: '#dc3545', color: 'white', padding: '16px 32px', border: 'none', borderRadius: '6px', fontSize: '18px', fontWeight: '500', cursor: 'pointer' },
};

export default MainPage;